import React,{useState} from "react";
import { Navbar, Nav, Row, Col, Container } from "react-bootstrap";
import FeedBackMoodal from "../feedback";

const Footer = () => {
  const [show, setShow] = useState(false);

  const onClose = () => {
    setShow(false);
  };

  return (
    <div
      // style={{ position: "fixed", bottom: "0", left: "0", right: "0" }}
      className="footer d-block bg-dark text-light pt-4"
    >
      <Container className="text-center text-md-left">
        <Row className="ml-2 mr-2 mb-1">
          <Col md={6}>
            <h5 className="text-light">Covid Resources 21</h5>
            <p>Community-based portal for Covid resources</p>
          </Col>
          <Col md={3}>
            {/* <h5 className=" ml-3">Important Links</h5> */}
            <Nav.Link
              href="mailto:contact@cr21.ml"
              className="text-info"
            >
              Contact us@cr21.ml
            </Nav.Link>
          </Col>
          <Col md={3}>
            {/* <h5 className=" ml-3">Other Links</h5> */}
            <Nav.Link
              className="text-info"
              onClick={() => setShow(true)}>
              Give Feedback
            </Nav.Link>
          </Col>
        </Row>
      </Container>
      <div className="text-center py-3" style={{background:"#111"}}>
        &copy; {new Date().getFullYear()} :
        <a href="https://cr21.ml" className="text-info ml-auto">
          {" "}
          cr21.ml{" "}
        </a>
      </div>
      <FeedBackMoodal show={show} onClose={onClose} />
    </div>
  );
};

export default Footer;
